import { FormLabel, Input, Flex, Switch } from "@chakra-ui/react";
import ButtonWithConfirm from "components/Button/ButtonWithConfirm";
import { PropsWithChildren, useState } from "react";
import { PrimaryButton } from "components/Button";
import { useDuplicatePrebuiltPath } from "../hooks";
import { PrebuiltPath } from "../models";

interface UsePrebuiltPathButtonProps extends PropsWithChildren {
  prebuiltPath: PrebuiltPath;
}

export default function UsePrebuiltPathButton({ children, prebuiltPath }: UsePrebuiltPathButtonProps) {
  const [customName, setCustomName] = useState(prebuiltPath?.name);
  const [autoAdd, setAutoAdd] = useState(false);

  const handleToggle = () => {
    setAutoAdd((a) => !a);
  };

  const { mutate: duplicatePath } = useDuplicatePrebuiltPath({ prebuiltPathId: prebuiltPath?.id });

  return (
    <ButtonWithConfirm
      buttonText="Use Prebuilt Path"
      header="Use Prebuilt Path"
      confirmButtonText="Confirm"
      body={(
        <>
          <FormLabel>Name</FormLabel>
          <Input placeholder="Enter a name" value={customName} onChange={(e) => setCustomName(e.target.value)} />
          <Flex alignItems="center" mt="2">
            <FormLabel>Auto Assign on Onboarding Kick Off?</FormLabel>
            <Switch id="autoAdd" onChange={handleToggle} isChecked={autoAdd} />
          </Flex>
        </>
      )}
      handleConfirm={() => duplicatePath({ name: customName, autoAdd })}
      intent="confirmation"
    >
      {children || (
        <PrimaryButton size="xs">
          Use Prebuilt Path
        </PrimaryButton>
      )}
    </ButtonWithConfirm>
  );
}
